<template>
    <fragment v-if="!loading">
        <div
            class="pb-5 space-y-3 border-b border-gray-200 sm:flex sm:items-center sm:justify-between "
        >
            <h3 class="text-lg font-medium leading-6 text-gray-900">
                Business Plans
            </h3>
            <div class="flex space-x-6 items-center">
                <downloadexcel
                    :fetch="exportCsv"
                    :fields="csv_json_fields"
                    :before-generate="startCsvDownload"
                    :before-finish="finishCsvDownload"
                    class="inline-flex items-center justify-center  px-6 py-1.5 text-sm font-medium leading-6 text-white transition duration-150 ease-in-out bg-green-500 border border-transparent rounded-md hover:bg-green-400 focus:outline-none focus:border-green-600 focus:shadow-outline-blue active:bg-green-600"
                >
                    <svg
                        v-if="CsvLoading"
                        class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle
                            class="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            stroke-width="4"
                        ></circle>
                        <path
                            class="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                    </svg>
                    Export
                </downloadexcel>
                <CustomSelect
                    v-on:selectItemClicked="statusFilterClicked"
                    placeholder="Filtre par Status"
                    :items="['Succès', 'Sans prêt', 'Danger', 'Avertissement']"
                    :filterPicked="statusFilter"
                />
                <CustomSelect
                    v-on:selectItemClicked="etatBPFilterClicked"
                    placeholder="Filtre par Etat du BP"
                    :items="['Traité', 'Finalisé', 'Contacté', 'Nouveau']"
                    :filterPicked="etatBPFilter"
                />

                <label for="search_par_cin" class="sr-only">Search</label>
                <div class="flex rounded-md shadow-sm">
                    <div class="relative flex-grow focus-within:z-10">
                        <div
                            class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
                        >
                            <svg
                                class="w-5 h-5 text-gray-400"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                    clip-rule="evenodd"
                                />
                            </svg>
                        </div>
                        <input
                            v-model="cin"
                            id="search_candidate"
                            class="hidden w-full pl-10 transition duration-150 ease-in-out rounded-none form-input rounded-l-md sm:block sm:text-sm sm:leading-5"
                            placeholder="Search CIN"
                        />
                    </div>
                    <button
                        @click="search"
                        class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out border border-gray-300 rounded-r-md bg-gray-50 hover:text-gray-500 hover:bg-white focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700"
                    >
                        <span class="ml-2">Search</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="flex flex-col ">
            <!-- sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 -->
            <div class="py-2 -my-2 ">
                <!-- mx-10  -->
                <div
                    class="inline-block w-full align-middle shadow sm:rounded-lg"
                >
                    <table class="w-full border-t border-gray-200 ">
                        <thead>
                            <tr>
                                <th
                                    class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
                                >
                                    Entreprise
                                </th>
                                <th
                                    class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
                                >
                                    contact
                                </th>
                                <th
                                    class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
                                >
                                    message
                                </th>
                                <th
                                    class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
                                >
                                    Status
                                </th>
                                <th
                                    class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
                                >
                                    état du BP
                                </th>
                                <th
                                    class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
                                >
                                    Date
                                </th>
                                <th
                                    class="px-6 py-3 border-b border-gray-200 bg-gray-50"
                                ></th>
                            </tr>
                        </thead>
                        <tbody
                            class="bg-white"
                            v-for="(bpi, index) in currentBpis"
                            :key="index"
                        >
                            <tr>
                                <td class="px-6 py-4 border-b border-gray-200">
                                    <div
                                        class="text-sm font-medium leading-5 text-gray-900"
                                    >
                                        <!--                              {{ bpi.forms.user.name }}-->
                                    </div>
                                    <div
                                        class="text-sm leading-5 text-gray-500 capitalize"
                                    >
                                        {{
                                            bpi.forms.entreprise_info !==
                                            undefined
                                                ? bpi.forms.entreprise_info.name
                                                : "null"
                                        }}
                                    </div>
                                </td>
                                <td class="px-6 py-4 border-b border-gray-200">
                                    <div
                                        class="text-sm leading-5 text-gray-900 capitalize"
                                    >
                                        {{
                                            bpi.forms.user.name +
                                                " / " +
                                                bpi.forms.user.email
                                        }}
                                    </div>
                                    <div
                                        class="text-sm leading-5 text-gray-500"
                                    >
                                        {{
                                            bpi.forms.user.phoneNumber !==
                                            undefined
                                                ? bpi.forms.user.phoneNumber
                                                : " "
                                        }}
                                    </div>
                                </td>
                                <td class="px-6 py-4 border-b border-gray-200 ">
                                    <div
                                        class="text-sm leading-5 text-gray-900"
                                    >
                                        {{ message(bpi) }}
                                    </div>
                                    <div
                                        class="text-sm leading-5 text-gray-500"
                                    >
                                        {{ subMessage(bpi) }}
                                    </div>
                                </td>
                                <td
                                    class="px-6 py-4 text-sm leading-5 text-gray-500 border-b border-gray-200"
                                >
                                    <span
                                        class="inline-flex px-2 text-xs font-semibold leading-5 rounded-full "
                                        :class="{
                                            'bg-green-100 text-green-800':
                                                bpi.outPut.status ===
                                                    'Succès' ||
                                                bpi.outPut.status ===
                                                    'Sans prêt',
                                            'bg-red-100 text-red-800':
                                                bpi.outPut.status === 'Danger',
                                            'bg-yellow-100 text-yellow-800':
                                                bpi.outPut.status ===
                                                'Avertissement'
                                        }"
                                    >
                                        {{ bpi.outPut.status }}
                                    </span>
                                </td>
                                <td
                                    class="px-6 py-4 text-sm leading-5 text-gray-500 border-b border-gray-200"
                                >
                                    <div
                                        @keydown.escape="bpi.openState = false"
                                        class="relative inline-block text-left"
                                    >
                                        <button
                                            @click="toggleState(index)"
                                            class="flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:text-gray-600"
                                        >
                                            <span
                                                class="inline-flex px-2 text-xs font-semibold leading-5 rounded-full"
                                                :class="{
                                                    'text-indigo-800 bg-indigo-100':
                                                        bpi.forms.State ===
                                                        'Traité',
                                                    'text-green-800 bg-green-100':
                                                        bpi.forms.State ===
                                                        'Finalisé',
                                                    'text-orange-800 bg-orange-100':
                                                        bpi.forms.State ===
                                                        'Contacté',
                                                    'text-yellow-800 bg-yellow-100':
                                                        bpi.forms.State ===
                                                            'Nouveau' ||
                                                        bpi.forms.State ===
                                                            undefined
                                                }"
                                            >
                                                {{
                                                    bpi.forms.State ===
                                                    undefined
                                                        ? "Nouveau"
                                                        : bpi.forms.State
                                                }}
                                                <svg
                                                    v-show="
                                                        bpi.openState === false
                                                    "
                                                    class="w-5 h-5"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="M19 9l-7 7-7-7"
                                                    ></path>
                                                </svg>
                                                <svg
                                                    v-show="
                                                        bpi.openState === true
                                                    "
                                                    class="w-5 h-5"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="M5 15l7-7 7 7"
                                                    ></path>
                                                </svg>
                                            </span>
                                        </button>

                                        <div
                                            class="absolute right-0 z-40 w-56 mt-2 origin-top-right rounded-md shadow-lg"
                                            v-show="bpi.openState"
                                        >
                                            <transition
                                                enter-active-class="transition duration-100 ease-out"
                                                enter-class="scale-95 opacity-0"
                                                enter-to-class="scale-100 opacity-100"
                                                leave-active-class="transition duration-75 ease-in transform duration-75ease-in"
                                                leave-class="scale-100 opacity-100"
                                                leave-to-class="scale-95 opacity-0"
                                            >
                                                <div
                                                    class="bg-white rounded-md shadow-xs"
                                                >
                                                    <div class="py-1">
                                                        <a
                                                            @click="
                                                                changeState(
                                                                    bpi,
                                                                    index,
                                                                    'Nouveau'
                                                                )
                                                            "
                                                            class="block px-4 py-2 text-sm leading-5 text-gray-700 cursor-pointer hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                                            >Nouveau</a
                                                        >
                                                        <a
                                                            @click="
                                                                changeState(
                                                                    bpi,
                                                                    index,
                                                                    'Contacté'
                                                                )
                                                            "
                                                            class="block px-4 py-2 text-sm leading-5 text-gray-700 cursor-pointer hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                                            >Contacté</a
                                                        >
                                                        <a
                                                            @click="
                                                                changeState(
                                                                    bpi,
                                                                    index,
                                                                    'Traité'
                                                                )
                                                            "
                                                            class="block px-4 py-2 text-sm leading-5 text-gray-700 cursor-pointer hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                                            >Traité</a
                                                        ><a
                                                            @click="
                                                                changeState(
                                                                    bpi,
                                                                    index,
                                                                    'Finalisé'
                                                                )
                                                            "
                                                            class="block px-4 py-2 text-sm leading-5 text-gray-700 cursor-pointer hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                                            >Finalisé</a
                                                        >
                                                    </div>
                                                </div>
                                            </transition>
                                        </div>
                                    </div>
                                </td>
                                <td
                                    class="px-6 py-4 text-sm leading-5 text-gray-500 border-b border-gray-200"
                                >
                                    {{
                                        new Date(
                                            bpi.forms.ValidationDate
                                        ).toLocaleDateString("fr-fr")
                                    }}
                                </td>
                                <td
                                    class="px-6 py-4 text-sm font-medium leading-5 text-right border-b border-gray-200"
                                >
                                    <span
                                        href="#"
                                        class="flex space-x-1 text-blue-600 focus:outline-none focus:underline"
                                    >
                                        <svg
                                            @click="selectBpiEdited(bpi)"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                            class="w-6 h-6 cursor-pointer pencil-alt hover:text-blue-900"
                                        >
                                            <path
                                                d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z"
                                            ></path>
                                            <path
                                                fill-rule="evenodd"
                                                d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                                                clip-rule="evenodd"
                                            ></path>
                                        </svg>
                                        <svg
                                            v-tooltip="`bpi out-put`"
                                            @click="selectBpiViewed(bpi)"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                            class="w-6 h-6 cursor-pointer hover:text-blue-900"
                                        >
                                            <path
                                                d="M10 12a2 2 0 100-4 2 2 0 000 4z"
                                            ></path>
                                            <path
                                                fill-rule="evenodd"
                                                d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                                                clip-rule="evenodd"
                                            ></path>
                                        </svg>

                                        <svg
                                            @click="openDeleteConfirmation(bpi)"
                                            class="w-6 h-6 cursor-pointer hover:text-blue-900"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                            ></path>
                                        </svg>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <BaseModalConfirmation
                        v-if="isOpenDeleteConfirmation"
                        v-on:confirmationResult="archiveBpi"
                    >
                        <div
                            class="flex items-center justify-center w-12 h-12 mx-auto rounded-full"
                        >
                            <svg
                                class="w-10 h-10"
                                viewBox="0 0 512 512"
                                width="512pt"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm0 0"
                                    fill="rgba(240, 82, 82,1)"
                                />
                                <path
                                    d="m350.273438 320.105469c8.339843 8.34375 8.339843 21.824219 0 30.167969-4.160157 4.160156-9.621094 6.25-15.085938 6.25-5.460938 0-10.921875-2.089844-15.082031-6.25l-64.105469-64.109376-64.105469 64.109376c-4.160156 4.160156-9.621093 6.25-15.082031 6.25-5.464844 0-10.925781-2.089844-15.085938-6.25-8.339843-8.34375-8.339843-21.824219 0-30.167969l64.109376-64.105469-64.109376-64.105469c-8.339843-8.34375-8.339843-21.824219 0-30.167969 8.34375-8.339843 21.824219-8.339843 30.167969 0l64.105469 64.109376 64.105469-64.109376c8.34375-8.339843 21.824219-8.339843 30.167969 0 8.339843 8.34375 8.339843 21.824219 0 30.167969l-64.109376 64.105469zm0 0"
                                    fill="#fafafa"
                                />
                            </svg>
                        </div>
                        <div class="mt-3 text-center sm:mt-5">
                            <h3
                                class="text-lg font-medium leading-6 text-gray-900"
                                id="modal-headline"
                            ></h3>
                            <div class="mt-2">
                                <p class="text-sm leading-5 text-gray-500">
                                    Etes vous sur de supprimer le Business Plan
                                    d'entreprise
                                    {{
                                        bpiToBeDeleted.forms.entreprise_info !==
                                        undefined
                                            ? bpiToBeDeleted.forms
                                                  .entreprise_info.name
                                            : "null"
                                    }}?
                                </p>
                            </div>
                        </div>
                    </BaseModalConfirmation>
                    <div
                        class="flex items-center justify-between w-full px-4 py-3 bg-white border-t border-gray-200 sm:px-6"
                    >
                        <div class="flex justify-between flex-1 sm:hidden">
                            <a
                                href="#"
                                class="relative inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700"
                            >
                                Previous
                            </a>
                            <a
                                href="#"
                                class="relative inline-flex items-center px-4 py-2 ml-3 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700"
                            >
                                Next
                            </a>
                        </div>
                        <div
                            class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between"
                        >
                            <div></div>
                            <div>
                                <nav class="relative z-0 inline-flex shadow-sm">
                                    <button
                                        :disabled="isPrevPageDisabled"
                                        v-if="page !== 1"
                                        @click="prevBpi"
                                        class="relative inline-flex items-center px-2 py-2 text-sm font-medium leading-5 text-gray-500 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-l-md hover:text-gray-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-500"
                                        aria-label="Previous"
                                    >
                                        <svg
                                            class="w-5 h-5"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                                                clip-rule="evenodd"
                                            />
                                        </svg>
                                    </button>

                                    <!-- v-if="!(page === 1 && nextBpis === null)" -->
                                    <span
                                        class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium leading-5 text-gray-700 bg-white border border-gray-300"
                                    >
                                        {{ page }}
                                    </span>

                                    <button
                                        :disabled="isNextPageDisabled"
                                        v-if="nextBpis !== null"
                                        @click="nexBpis"
                                        class="relative inline-flex items-center px-2 py-2 -ml-px text-sm font-medium leading-5 text-gray-500 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-r-md hover:text-gray-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-500"
                                        aria-label="Next"
                                    >
                                        <svg
                                            class="w-5 h-5"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                                clip-rule="evenodd"
                                            />
                                        </svg>
                                    </button>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <base-search-modal
            :open="isSearching"
            @modal-close="isSearching = false"
            :info="searchResult"
            :loading="modalLoading"
        />
    </fragment>
</template>

<script>
import { db } from "@/services/firebase.service";
import NProgress from "nprogress";
import { cloneDeep } from "lodash";
import CustomSelect from "./components/validatedBpi/customSelect";
import JsonExcel from "vue-json-excel";

export default {
    components: {
        CustomSelect,
        downloadexcel: JsonExcel
    },
    data() {
        return {
            csv_json_fields: {
                "nom complet": "name",
                CIN: "cin",
                TELEPHONE: "phoneNumber",
                "Raison sociale": "entrepriseName",
                adresse: "adresse",
                "Statut juridique": "legalForm",
                "secteur d'activite": "actevity",
                "DESCRIPTION DU PROJET": "description",
                "Montant sollicité": "credit",
                "NOMBRE D'EMPLOIS A CREER": "empolyersNumber"
            },
            CsvLoading: false,
            statusFilter: "",
            etatBPFilter: "",
            isOpenDeleteConfirmation: false,
            bpiToBeDeleted: {},
            isSearching: false,
            currentBpis: [],
            nextBpis: [],
            prevBpis: [],
            open: false,
            sidebarOpen: false,
            currentDocs: [],
            nextDocs: [],
            prevDocs: [],
            prevDocPointer: null,
            nextDocPointer: null,
            pageBpis: new Map(),
            page: 1,
            cin: "",
            loading: false,
            searchResult: {},
            modalLoading: true,
            etatOpen: false,
            isNextPageDisabled: false,
            isPrevPageDisabled: false
        };
    },

    mounted() {
        this.getUnfiltredBpis();
    },
    methods: {
        startCsvDownload() {
            this.CsvLoading = true;
        },
        finishCsvDownload() {
            this.CsvLoading = false;
        },

        async exportCsv() {
            const getActivity = id => {
                return this.$store.state.forms.VotreProject.Sectors.filter(
                    elem => elem.value == id
                )[0];
            };

            const snapshot = await db
                .collection("bpis")
                .where("validation", "==", true)
                .orderBy("ValidationDate", "desc")
                .get();
            const data = [];
            for await (const doc of snapshot.docs) {
                let user = await db
                    .collection("users")
                    .doc(doc.data().user.uid)
                    .get();
                let bpiData = doc.data();
                let userData = user.data();

                data.push({
                    name: userData.name,
                    cin: userData.cin,
                    phoneNumber: userData.phoneNumber,
                    adresse: bpiData.investors_profiles[0].address,
                    entrepriseName: bpiData.entreprise_info.name,
                    legalForm: bpiData.entreprise_info.legalForm,
                    actevity: getActivity(bpiData.project_info.activity).text,
                    description: bpiData.project_info.description,
                    credit: Array.isArray(
                        bpiData.investors_programme.creditBancaire
                    )
                        ? bpiData.investors_programme.creditBancaire?.reduce(
                              (accumulator, currentValue) => {
                                  return currentValue.montant + accumulator;
                              },
                              0
                          )
                        : bpiData.investors_programme.creditBancaire.montant,
                    empolyersNumber:
                        bpiData.moyens_humains?.reduce(
                            (accumulator, currentValue) => {
                                return currentValue.value + accumulator;
                            },
                            0
                        ) || 0
                });
            }
            return data;
        },

        async nextUnfiltredBpis() {
            NProgress.start();
            this.isNextPageDisabled = true;
            this.prevBpis = cloneDeep(this.currentBpis);
            this.currentBpis = cloneDeep(this.nextBpis);
            if (this.pageBpis.has(`page${this.page + 2}`)) {
                this.nextBpis = this.pageBpis.get(`page${this.page + 2}`);
                this.isNextPageDisabled = false;
                this.page++;
                NProgress.done();
            } else {
                try {
                    const snapshot = await db
                        .collection("bpis")
                        .where("validation", "==", true)
                        .orderBy("ValidationDate", "desc")
                        .startAfter(this.nextDocPointer)
                        .limit(10)
                        .get();
                    if (snapshot.size !== 0) {
                        this.nextDocs = snapshot.docs;
                        this.nextDocPointer =
                            snapshot.docs[snapshot.docs.length - 1];
                        this.nextBpis = [];
                        for await (const doc of snapshot.docs) {
                            let nextBpisData = doc.data();
                            let nextUserUID = nextBpisData.user.uid;
                            let user = await db
                                .collection("users")
                                .doc(nextUserUID)
                                .get();
                            this.nextBpis.push({
                                forms: { ...nextBpisData, user: user.data() },
                                id: doc.id
                            });
                        }
                    } else {
                        this.nextBpis = null;
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    if (this.nextBpis !== null)
                        this.nextBpis.forEach((bpi, index) => {
                            db.collection("bpis_output")
                                .doc(bpi.id)
                                .get()
                                .then(data => {
                                    this.nextBpis[index] = {
                                        outPut: data.data(),
                                        id: data.id,
                                        ...this.nextBpis[index]
                                    };
                                });
                        });
                    this.page++;
                    this.pageBpis.set(`page${this.page + 1}`, this.nextBpis);
                    this.isNextPageDisabled = false;
                    NProgress.done();
                }
            }
        },
        async getUnfiltredBpis() {
            this.pageBpis = new Map();
            this.page = 1;
            this.nextBpis = [];
            this.prevBpis = [];

            NProgress.start();

            this.loading = true;
            this.isNextPageDisabled = false;
            this.nextDocPointer = null;

            try {
                const querySnapshot = await db
                    .collection("bpis")
                    .where("validation", "==", true)
                    .orderBy("ValidationDate", "desc")
                    .limit(10)
                    .get();
                this.currentDocs = cloneDeep(querySnapshot.docs);
                this.currentBpis = [];
                for await (const doc of querySnapshot.docs) {
                    let currentBpiData = doc.data();
                    let currentUserUID = currentBpiData.user.uid;
                    let user = await db
                        .collection("users")
                        .doc(currentUserUID)
                        .get();
                    this.currentBpis.push({
                        forms: { ...currentBpiData, user: user.data() },
                        id: doc.id
                    });
                }
            } catch (error) {
                console.log(error);
            } finally {
                try {
                    for await (const [
                        index,
                        bpi
                    ] of this.currentBpis.entries()) {
                        const data = await db
                            .collection("bpis_output")
                            .doc(bpi.id)
                            .get();
                        this.currentBpis[index] = {
                            outPut: data.data(),
                            id: data.id,
                            openState: false,
                            ...this.currentBpis[index]
                        };
                    }
                    this.pageBpis.set(`page${this.page}`, this.currentBpis);
                    this.nextDocPointer = this.currentDocs[
                        this.currentDocs.length - 1
                    ];
                    this.prevDocPointer = this.currentDocs[0];
                    const snapshot = await db
                        .collection("bpis")
                        .where("validation", "==", true)
                        .orderBy("ValidationDate", "desc")
                        .startAfter(this.nextDocPointer)
                        .limit(10)
                        .get();
                    if (snapshot.size !== 0) {
                        this.nextDocs = snapshot.docs;
                        this.nextDocPointer =
                            snapshot.docs[snapshot.docs.length - 1];
                        this.nextBpis = [];
                        for await (const snap of snapshot.docs) {
                            let nextBpisBpiData = snap.data();
                            let nextUserUID = nextBpisBpiData.user.uid;
                            let user = await db
                                .collection("users")
                                .doc(nextUserUID)
                                .get();
                            this.nextBpis.push({
                                forms: {
                                    ...nextBpisBpiData,
                                    user: user.data()
                                },
                                id: snap.id
                            });
                        }
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    if (this.nextBpis !== null)
                        this.nextBpis.forEach((bpi, index) => {
                            db.collection("bpis_output")
                                .doc(bpi.id)
                                .get()
                                .then(data => {
                                    this.nextBpis[index] = {
                                        outPut: data.data(),
                                        id: data.id,
                                        ...this.nextBpis[index]
                                    };
                                });
                        });
                    this.pageBpis.set(`page${this.page + 1}`, this.nextBpis);
                    NProgress.done();
                    this.loading = false;
                    this.$emit("fetching-data", false);
                }
            }
        },
        async getBPIsWhenStatusFilter() {
            this.pageBpis = new Map();
            this.page = 1;
            this.nextBpis = [];
            this.prevBpis = [];

            NProgress.start();

            this.loading = true;
            this.isNextPageDisabled = false;
            this.nextDocPointer = null;

            try {
                const bpisStatusCollection = db.collection("bpis_output");

                let querySnapshot = [];
                if (this.statusFilter == "") {
                    querySnapshot = await bpisStatusCollection.limit(10).get();
                } else {
                    querySnapshot = await bpisStatusCollection
                        .where("status", "==", this.statusFilter)
                        .limit(10)
                        .get();
                }

                this.currentDocs = cloneDeep(querySnapshot.docs);

                this.currentBpis = [];
                for await (const document of querySnapshot.docs) {
                    let currentStatutId = document.id;
                    let bpi = await db
                        .collection("bpis")
                        .doc(currentStatutId)
                        .get();

                    let bpiData = bpi.data();
                    if (bpiData !== undefined) {
                        let user = await db
                            .collection("users")
                            .doc(bpiData.user.uid)
                            .get();
                        let userData = user.data();
                        this.currentBpis.push({
                            outPut: document.data(),
                            forms: {
                                ...bpiData,
                                user: userData
                            },
                            id: document.id
                        });
                    }
                }
            } catch (error) {
                console.log(error);
            } finally {
                try {
                    this.nextDocPointer = this.currentDocs[
                        this.currentDocs.length - 1
                    ];
                    this.prevDocPointer = this.currentDocs[0];
                    let snapshot = [];
                    if (this.statusFilter === "") {
                        snapshot = await db
                            .collection("bpis_output")
                            .startAfter(this.nextDocPointer)
                            .limit(10)
                            .get();
                    } else {
                        snapshot = await db
                            .collection("bpis_output")
                            .where("status", "==", this.statusFilter)
                            .startAfter(this.nextDocPointer)
                            .limit(10)
                            .get();
                    }

                    if (snapshot.size !== 0) {
                        this.pageBpis.set(`page${this.page}`, this.currentBpis);

                        this.nextDocs = snapshot.docs;
                        this.nextDocPointer =
                            snapshot.docs[snapshot.docs.length - 1];

                        this.nextBpis = [];
                        for await (const snap of snapshot.docs) {
                            let currentStatutId = snap.id;
                            let bpi = await db
                                .collection("bpis")
                                .doc(currentStatutId)
                                .get();

                            let bpiData = bpi.data();
                            if (bpiData !== undefined) {
                                let user = await db
                                    .collection("users")
                                    .doc(bpiData.user.uid)
                                    .get();
                                let userData = user.data();
                                this.nextBpis.push({
                                    outPut: snap.data(),
                                    forms: {
                                        ...bpiData,
                                        user: userData
                                    },
                                    id: snap.id
                                });
                            }
                        }
                        this.pageBpis.set(
                            `page${this.page + 1}`,
                            this.nextBpis
                        );
                    } else {
                        this.nextDocPointer = null;
                        this.nextDocs = null;
                        this.nextBpis = null;
                        this.isNextPageDisabled = true;
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    NProgress.done();
                    this.loading = false;
                    this.$emit("fetching-data", false);
                }
            }
        },
        async getBPIsWhenEtatBPFilter() {
            this.pageBpis = new Map();
            this.page = 1;
            this.nextBpis = [];
            this.prevBpis = [];

            NProgress.start();

            this.loading = true;
            this.isNextPageDisabled = false;
            this.nextDocPointer = null;

            try {
                let bpisCollection = db.collection("bpis");
                bpisCollection = bpisCollection.where("validation", "==", true);
                bpisCollection = bpisCollection.orderBy(
                    "ValidationDate",
                    "desc"
                );

                bpisCollection = bpisCollection.where(
                    "State",
                    "==",
                    this.etatBPFilter
                );

                let querySnapshot = await bpisCollection.limit(10).get();

                this.currentDocs = cloneDeep(querySnapshot.docs);

                this.currentBpis = [];

                for await (const doc of querySnapshot.docs) {
                    let currentBpiData = doc.data();
                    let currentUserUID = currentBpiData.user.uid;

                    let user = await db
                        .collection("users")
                        .doc(currentUserUID)
                        .get();

                    this.currentBpis.push({
                        forms: { ...currentBpiData, user: user.data() },
                        id: doc.id
                    });
                }
            } catch (error) {
                console.log(error);
            } finally {
                try {
                    for await (const [
                        index,
                        bpi
                    ] of this.currentBpis.entries()) {
                        const data = await db
                            .collection("bpis_output")
                            .doc(bpi.id)
                            .get();
                        this.currentBpis[index] = {
                            outPut: data.data(),
                            id: data.id,
                            openState: false,
                            ...this.currentBpis[index]
                        };
                    }

                    this.pageBpis.set(`page${this.page}`, this.currentBpis);

                    this.nextDocPointer = this.currentDocs[
                        this.currentDocs.length - 1
                    ];

                    this.prevDocPointer = this.currentDocs[0];

                    let coll = db.collection("bpis");

                    coll = coll.where("validation", "==", true);
                    coll = coll.where("State", "==", this.etatBPFilter);

                    const snapshot = await coll
                        .startAfter(this.nextDocPointer)
                        .limit(10)
                        .get();

                    if (snapshot.size === 10) {
                        this.nextDocs = snapshot.docs;
                        this.nextDocPointer =
                            snapshot.docs[snapshot.docs.length - 1];

                        this.nextBpis = [];
                        for await (const snap of snapshot.docs) {
                            let nextBpisBpiData = snap.data();
                            let nextUserUID = nextBpisBpiData.user.uid;

                            let user = await db
                                .collection("users")
                                .doc(nextUserUID)
                                .get();

                            this.nextBpis.push({
                                forms: {
                                    ...nextBpisBpiData,
                                    user: user.data()
                                },
                                id: snap.id
                            });
                        }
                    } else {
                        this.nextDocPointer = null;
                        this.nextDocs = null;
                        this.nextBpis = null;
                        this.isNextPageDisabled = true;
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    if (this.nextBpis !== null) {
                        this.nextBpis.forEach((bpi, index) => {
                            db.collection("bpis_output")
                                .doc(bpi.id)
                                .get()
                                .then(data => {
                                    this.nextBpis[index] = {
                                        outPut: data.data(),
                                        id: data.id,
                                        ...this.nextBpis[index]
                                    };
                                });
                        });
                    }

                    this.pageBpis.set(`page${this.page + 1}`, this.nextBpis);

                    NProgress.done();
                    this.loading = false;
                    this.$emit("fetching-data", false);
                }
            }
        },
        etatBPFilterClicked(etat) {
            this.etatBPFilter = etat;
            this.statusFilter = "";
            if (this.etatBPFilter == "") this.getUnfiltredBpis();
            else this.getBPIsWhenEtatBPFilter();
        },
        statusFilterClicked(status) {
            this.etatBPFilter = "";
            this.statusFilter = status;
            if (this.statusFilter == "") this.getUnfiltredBpis();
            else this.getBPIsWhenStatusFilter();
        },
        selectBpiEdited(bpi) {
            this.$store.dispatch("user/AdminSelectBpi", bpi.id);
        },
        selectBpiViewed(bpi) {
            this.$store
                .dispatch("user/selectBpiOutPut", {
                    bpi: bpi.forms,
                    uid: bpi.id
                })
                .then(uid => {
                    this.$router.push({
                        name: "output",
                        query: { uid: `${uid}` }
                    });
                });
        },
        downloadBpi(bpi) {
            NProgress.start();
            this.$store
                .dispatch("user/downloadBpi", {
                    uid: bpi.id,
                    fileName: bpi.forms.entreprise_info.name
                })
                .then(() => {
                    NProgress.done();
                })
                .catch(() => {});
        },
        deleteBpi(bpi) {
            db.collection("bpis")
                .doc(`${bpi.id}`)
                .delete()
                .then(function() {
                    console.log("Document successfully deleted!");
                })
                .catch(function(error) {
                    console.error("Error removing document: ", error);
                });
            db.collection("bpis_output")
                .doc(`${bpi.id}`)
                .delete()
                .then(function() {
                    console.log("Document successfully deleted!");
                })
                .catch(function(error) {
                    console.error("Error removing document: ", error);
                });
            db.collection("users")
                .doc(`${bpi.forms.user.uid}`)
                .delete()
                .then(function() {
                    console.log("Document successfully deleted!");
                })
                .catch(function(error) {
                    console.error("Error removing document: ", error);
                });
        },
        async nextStatusFiltredBpis() {
            NProgress.start();

            this.isNextPageDisabled = true;

            this.prevBpis = cloneDeep(this.currentBpis);
            this.currentBpis = cloneDeep(this.nextBpis);

            if (this.pageBpis.has(`page${this.page + 2}`)) {
                this.nextBpis = this.pageBpis.get(`page${this.page + 2}`);
                this.isNextPageDisabled = false;
                this.page++;
                NProgress.done();
            } else {
                try {
                    const snapCollection = db.collection("bpis_output");
                    let snapshot = [];

                    snapshot = await snapCollection
                        .where("status", "==", this.statusFilter)
                        .startAfter(this.nextDocPointer)
                        .limit(10)
                        .get();

                    if (snapshot.size !== 0) {
                        this.nextDocs = snapshot.docs;
                        this.nextDocPointer =
                            snapshot.docs[snapshot.docs.length - 1];
                        this.nextBpis = [];
                        for await (const document of snapshot.docs) {
                            let currentStatutId = document.id;
                            let bpi = await db
                                .collection("bpis")
                                .doc(currentStatutId)
                                .get();

                            let bpiData = bpi.data();
                            if (bpiData !== undefined) {
                                let user = await db
                                    .collection("users")
                                    .doc(bpiData.user.uid)
                                    .get();
                                let userData = user.data();
                                this.nextBpis.push({
                                    outPut: document.data(),
                                    forms: {
                                        ...bpiData,
                                        user: userData
                                    },
                                    id: document.id
                                });
                            }
                        }
                    } else {
                        this.nextBpis = null;
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    this.page++;
                    this.pageBpis.set(`page${this.page + 1}`, this.nextBpis);
                    this.isNextPageDisabled = false;
                    NProgress.done();
                }
            }
        },
        async nextEtatFiltredBpis() {
            NProgress.start();
            this.isNextPageDisabled = true;
            this.prevBpis = cloneDeep(this.currentBpis);
            this.currentBpis = cloneDeep(this.nextBpis);
            if (this.pageBpis.has(`page${this.page + 2}`)) {
                this.nextBpis = this.pageBpis.get(`page${this.page + 2}`);
                this.isNextPageDisabled = false;
                this.page++;
                NProgress.done();
            } else {
                try {
                    let coll = db.collection("bpis");
                    coll = coll.where("validation", "==", true);
                    coll = coll.where("State", "==", this.etatBPFilter);
                    coll = coll.orderBy("ValidationDate", "desc");
                    coll = coll.startAfter(this.nextDocPointer);
                    const snapshot = await coll.limit(10).get();
                    if (snapshot.size !== 0) {
                        this.nextDocs = snapshot.docs;
                        this.nextDocPointer =
                            snapshot.docs[snapshot.docs.length - 1];
                        this.nextBpis = [];
                        for await (const doc of snapshot.docs) {
                            let nextBpisData = doc.data();
                            let nextUserUID = nextBpisData.user.uid;
                            let user = await db
                                .collection("users")
                                .doc(nextUserUID)
                                .get();
                            this.nextBpis.push({
                                forms: { ...nextBpisData, user: user.data() },
                                id: doc.id
                            });
                        }
                    } else {
                        this.nextBpis = null;
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    if (this.nextBpis !== null)
                        this.nextBpis.forEach((bpi, index) => {
                            db.collection("bpis_output")
                                .doc(bpi.id)
                                .get()
                                .then(data => {
                                    this.nextBpis[index] = {
                                        outPut: data.data(),
                                        id: data.id,
                                        ...this.nextBpis[index]
                                    };
                                });
                        });
                    this.page++;
                    this.pageBpis.set(`page${this.page + 1}`, this.nextBpis);
                    this.isNextPageDisabled = false;
                    NProgress.done();
                }
            }
        },
        nexBpis() {
            if (this.statusFilter !== "") this.nextStatusFiltredBpis();
            else if (this.etatBPFilter !== "") this.nextEtatFiltredBpis();
            else this.nextUnfiltredBpis();
        },
        openDeleteConfirmation(bpi) {
            this.bpiToBeDeleted = bpi;
            this.isOpenDeleteConfirmation = true;
        },
        archiveBpi(confirmationResult) {
            if (confirmationResult) {
                db.collection("bpis")
                    .doc(`${this.bpiToBeDeleted.id}`)
                    .update({
                        validation: "done"
                    })
                    .then(() => {
                        this.currentBpis = this.currentBpis.filter(item => {
                            return item.id !== this.bpiToBeDeleted.id;
                        });
                    })
                    .catch(function(error) {
                        console.error("Error archived document: ", error);
                    });
            }
            this.isOpenDeleteConfirmation = false;
        },
        changeState(bpi, index, state) {
            let notSuccess = true;
            db.collection("bpis")
                .doc(`${bpi.id}`)
                .update({
                    State: state
                })
                .then(() => {
                    this.$emit("showNotification", {
                        error: false,
                        content: "Status edited.",
                        title: "Successfully saved!"
                    });
                    this.currentBpis[index].forms.State = state;
                    this.toggleState(index);
                    notSuccess = false;
                })
                .catch(error => {
                    console.error("Error state of document: ", error);
                    this.$emit("showNotification", {
                        error: true,
                        content: "Error editing status.",
                        title: "Error"
                    });
                });

            if (!notSuccess) this.toggleState(index);
        },
        toggleState(index) {
            this.currentBpis[index].openState = !this.currentBpis[index]
                .openState;
            this.$forceUpdate();
        },
        async prevBpi() {
            NProgress.start();

            this.page--;
            this.currentBpis = this.pageBpis.get(`page${this.page}`);

            this.nextBpis = this.pageBpis.get(`page${this.page + 1}`);
            NProgress.done();
        },
        search() {
            this.modalLoading = true;
            this.isSearching = true;
            NProgress.start();

            db.collection("bpis")
                .where("user.cin", "==", `${this.cin}`)
                .get()
                .then(snapshot => {
                    if (snapshot.size !== 0) {
                        const doc = snapshot.docs[0];
                        db.collection("bpis_output")
                            .doc(doc.id)
                            .get()
                            .then(data => {
                                this.searchResult = {
                                    data: doc.data(),
                                    outPut: data.data(),
                                    id: doc.id,
                                    status: "ok"
                                };
                                NProgress.done();
                                this.modalLoading = false;
                            });
                    } else {
                        this.searchResult = {
                            status: "Non result"
                        };
                        NProgress.done();
                    }
                });
        }
    },
    computed: {
        message() {
            return bpi => {
                let total;
                if (bpi.forms.bpiVersion === "Version Simplifiée") {
                    total = bpi.forms.investors_programme.ITMO.reduce(
                        (a, b) => a + b.value,
                        0
                    );
                } else {
                    total =
                        bpi.forms.investors_programme.nonValueAssetTotal +
                        bpi.forms.investors_programme.tangibleAssetsTotal +
                        bpi.forms.investors_programme.intangibleAssetsTotal +
                        bpi.forms.investors_programme.diversImprevue;
                }

                if (total !== bpi.forms.investors_programme.capital)
                    return "Les montants totaux de PI et PF sont différents";
                return "";
            };
        },
        subMessage() {
            return bpi => {
                const index = bpi.outPut?.cpc.findIndex(
                    element => element.resultatNet <= 0
                );
                if (index !== -1)
                    return `Votre entreprise n’est pas rentable l’année ${new Date(
                        bpi.outPut?.generatedDate.seconds * 1000
                    ).getFullYear() +
                        index} veuillez revoir votre étude financière`;
                if (bpi.outPut?.van > 0)
                    return "Votre projet est rentable passez à l’action";
                if (bpi.outPut?.van < 0)
                    return "Votre projet n’est pas rentable veuillez revoir vos études financière et technique";
                return "";
            };
        }
    }
};
</script>

<style></style>
